export default __webpack_public_path__ + "2f943222924cc7b6ecb8e854426d3a11.png";